module.exports = __webpack_public_path__ + "img/40_69_003_340.77ee8388.jpg";